const SUPERADMIN_EMAIL = 'superadmin@webhr.in';
const SUPERADMIN_EMPLOYEE_ID = 'QA-SUP-1-0';

export const shouldHideSuperadminEmployee = (employee, currentUser) => {
  if (!employee || currentUser?.isSuperadmin) {
    return false;
  }

  const email = String(employee.email || '').trim().toLowerCase();
  const employeeId = String(employee.employee_id || '').trim();

  return email === SUPERADMIN_EMAIL || employeeId === SUPERADMIN_EMPLOYEE_ID;
};

export const filterVisibleEmployees = (employees, currentUser) =>
  (Array.isArray(employees) ? employees : []).filter(
    (employee) => !shouldHideSuperadminEmployee(employee, currentUser)
  );
